import { FC, SVGAttributes } from "react";

const FaceSmileIcon: FC<SVGAttributes<SVGSVGElement>> = ({
  stroke = "#CCCCCC",
  width = 24,
  height = 24,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    width={width}
    height={height}
    style={{ padding: 2 }}
  >
    <g
      strokeWidth="1.4"
      fill="none"
      fillRule="evenodd"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M35.3 18A17.3 17.3 0 1 0 .7 18a17.3 17.3 0 0 0 34.6 0z"></path>
      <path d="M27.72 18.9a9.86 9.86 0 0 1-.2 1.96A9.72 9.72 0 0 1 8.28 18.9"></path>
    </g>
  </svg>
);

export default FaceSmileIcon;
